import { ArrowBackIcon } from '@chakra-ui/icons';
import { Box, Heading, Text, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle } from "react-icons/fa";

export default function Success() {
    //hooks
    const navigate = useNavigate();
    // const history = ();

    return (
        <Box textAlign="center" py={10} px={6}>
            <Heading
                display="inline-block"
                as="h2"
                size="2xl"
                color="green"
            >
                <FaCheckCircle />
            </Heading>
            <Text fontSize="18px" mt={3} mb={2}>
                Success!
            </Text>
            <Text color={'gray.500'} mb={6}>
                Congratulations! You've successfully authorized your sub-account.
            </Text>

            <Button
                colorScheme="green"
                color="white"
                variant="solid"
                onClick={() => {
                    // history.clear();
                    // history.replace('/');
                    navigate("/", { replace: true })
                }}
                leftIcon={<ArrowBackIcon />}
            >
                Return
            </Button>
        </Box>
    );
}